<template>
  <div ref="widget" :class="['emojis-widget', emojiOpen ? 'is-open' : 'closed']">
    <div class="emoji-wrapper" ref="wrapper">
      <div class="emoji-section" @scroll="highlightVisibleCategory">
        <ul :id="'emoji-category-'+index"
            v-for="(emojiCategory, key, index) in groupedEmojis"
            :key="key"
            :ref="'emojiSection'+index">
          <li class="emoji-category">{{key}}</li>
          <li v-for="emojiItem in emojiCategory" :key="emojiItem.order">
            <a :title="emojiItem.annotation"
               @click="$emit('insertInTextArea', emojiItem.emoji)"
               class="emoji">{{emojiItem.emoji}}</a>
          </li>
        </ul>
      </div>
      <div class="emoji-category-section">
        <ul>
          <li v-for="(category, index) in categories"
              :class="['emoji-category', { active: categoryInView === index }]"
              :key="index"
              @click="scrollToCategory(index)">
            <svg :viewBox="category.viewbox" class="sb-icon">
              <use :xlink:href="'#'+category.iconName"></use>
            </svg>
          </li>
        </ul>
        <sms-action-footer @closeAction="$emit('closeEmoji', 'emoji', true)"></sms-action-footer>
      </div>
    </div>
  </div>
</template>

<script>
  import emojiData from '../../data/emojis.json'
  import { groupBy } from '../../utilities/index'
  import SmsActionFooter from '../Sms/SmsActionFooter'

  export default {
    props: {
      emojiOpen: Boolean,
    },

    name: 'Emojis',

    components: {
      SmsActionFooter,
    },

    data() {
      return {
        categories: null,
        categoryInView: 0,
        scrollTimeout: null,
      };
    },

    methods: {
      createCategory(category, onlyName) {
        let categoryItem = {}
        switch (category) {
          case 0:
            categoryItem = {
              iconName: 'smile',
              name: 'smileys & people',
              viewbox: '0 0 368 368'
            }
            break;
          case 1:
            categoryItem = {
              iconName: 'a-flower',
              name: 'animals & nature',
              viewbox: '0 0 512 512'
            }
            break;
          case 2:
            categoryItem = {
              iconName: 'burger',
              name: 'food & drink',
              viewbox: '0 0 512 512'
            }
            break;

          case 3:
            categoryItem = {
              iconName: 'car',
              name: 'travel & places',
              viewbox: '0 0 39.055 39.054'
            }
            break;

          case 4:
            categoryItem = {
              iconName: 'basketball',
              name: 'activities',
              viewbox: '0 0 512 512'
            }
            break;

          case 5:
            categoryItem = {
              iconName: 'light-bulb',
              name: 'objects',
              viewbox: '0 0 512 512'
            }
            break;

          case 6:
            categoryItem = {
              iconName: 'heart',
              name: 'symbols',
              viewbox: '0 -28 512.001 512'
            }
            break;

          case 7:
            categoryItem = {
              iconName: 'flag',
              name: 'flags',
              viewbox: '0 0 60 60'
            }
            break;
        }
        return onlyName ? categoryItem.name : categoryItem
      },

      highlightVisibleCategory(event) {
        const view = this
        clearTimeout(this.scrollTimeout)
        this.scrollTimeout = setTimeout(function () {
          const $target = event.target,
            sectionTop = $target.scrollTop,
            sectionBottom = $target.scrollTop + $target.clientHeight
          view.visibleCategory(sectionTop, sectionBottom)
        }, 50)
      },

      setCategories(groupedEmojis) {
        const view = this
        return Object.keys(groupedEmojis).map(function(groupedEmojisKey) {
          return view.createCategory(parseInt(groupedEmojisKey))
        })
      },

      scrollToCategory(emojiGroup) {
        // TODO animate scrolling ??
        const $emojiCategory = this.$refs[`emojiSection${emojiGroup}`][0],
          $emojiSection =  $emojiCategory.parentElement
        $emojiSection.scrollTo(1000, $emojiCategory.offsetTop)
      },

      visibleCategory(sectionTop, sectionBottom) {
        for (let i = 0; i < this.categories.length; i++) {
          let $emojiCategory = this.$refs[`emojiSection${i}`][0],
            categoryTop = $emojiCategory.offsetTop,
            categoryBottom =  categoryTop + $emojiCategory.clientHeight,
            rangeMin = Math.max(sectionTop, categoryTop),
            rangeMax = Math.min(sectionBottom, categoryBottom)
          if (rangeMin < rangeMax) {
            return this.categoryInView = i
          }
        }
      },
    },

    computed: {
      groupedEmojis: function () {
        // group is the same as category in the emojis data json file
        // getCategories(category, onlyName)
        const groupedEmojis = groupBy(emojiData, 'group')
        this.categories = this.setCategories(groupedEmojis)

        let groupedEmojisWithCategory = {}
        for (let key in groupedEmojis) {
          const category = this.createCategory(parseInt(key), true)
          groupedEmojisWithCategory[category] = groupedEmojis[key]
        }
        return groupedEmojisWithCategory
      },
    },
  }
</script>